import Banner from "../Allcomponent/Banner"
import Cards from "../Allcomponent/cards"
import Rowphoneone from "./rowphoneone"
import Rowtwo from "./rowtwo"
import Rowthree from './rowthree'
function Mobile (){
    return(
        <>
        <Banner/>
        <Cards/>
        <Rowphoneone/>
        <Rowtwo/>
        <Rowthree/>
        </>
    )
}
export default Mobile